import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { makeThemedStyles, DISPLAY_FONT } from '../v10/theme';
import { GlassFill } from './glass';

export function OlmpsHeader({
  title,
  canGoBack,
  onBack,
  onOpenDrawer,
}: {
  title: string;
  canGoBack: boolean;
  onBack: () => void;
  onOpenDrawer: () => void;
}) {
  const styles = useStyles();
  return (
    <View style={styles.row}>
      <GlassFill radius={0} />
      <Pressable onPress={onOpenDrawer} style={styles.button}>
        <View style={styles.hamburger}>
          <View style={styles.hamburgerLine} />
          <View style={styles.hamburgerLine} />
          <View style={styles.hamburgerLine} />
        </View>
      </Pressable>
      <Text style={styles.title}>{title}</Text>
      <Pressable
        onPress={onBack}
        disabled={!canGoBack}
        style={[styles.button, !canGoBack && styles.buttonDisabled]}
      >
        <Text style={styles.buttonText}>›</Text>
      </Pressable>
    </View>
  );
}

const useStyles = makeThemedStyles(({ t, neu }) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 12,
      backgroundColor: 'transparent',
      overflow: 'hidden',
      borderBottomWidth: 1,
      borderBottomColor: t.lineFaint,
    },
    button: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: t.glass,
      borderWidth: 1,
      borderColor: t.navyLine,
      alignItems: 'center',
      justifyContent: 'center',
      ...neu.raisedSm,
    },
    buttonDisabled: { opacity: 0.3 },
    buttonText: { fontSize: 20, fontWeight: '900', color: t.goldBright, lineHeight: 22 },
    hamburger: { width: 18, height: 13, justifyContent: 'space-between' },
    hamburgerLine: { height: 2, borderRadius: 1, backgroundColor: t.goldBright },
    title: {
      fontSize: 20,
      fontWeight: '800',
      letterSpacing: 3,
      color: t.ivory,
      fontFamily: DISPLAY_FONT,
      textTransform: 'uppercase',
    },
  }),
);
